import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { mapListingSummaryResponse } from '@core/models/listing.mapper';
import { ListingSummaryResponse } from '@core/models/listing.response';
import { ListingSummaryState } from '@core/models/listing.state';
import { ApiService } from '@core/services/api.service';

import { WatchlistPriceSnapshot, WatchlistRepository } from './watchlist.repository';

@Injectable()
export class WatchlistHttpRepository implements WatchlistRepository {
  private readonly api = inject(ApiService);

  ids(shopperId: number): Observable<number[]> {
    return this.api.get<number[]>(`shoppers/${shopperId}/watchlist/ids`);
  }

  priceSnapshots(shopperId: number): Observable<WatchlistPriceSnapshot[]> {
    return this.api.get<WatchlistPriceSnapshot[]>(`shoppers/${shopperId}/watchlist/price-snapshots`);
  }

  list(shopperId: number): Observable<ListingSummaryState[]> {
    return this.api
      .get<ListingSummaryResponse[]>(`shoppers/${shopperId}/watchlist`)
      .pipe(map(items => items.map(mapListingSummaryResponse)));
  }

  add(shopperId: number, listingId: number): Observable<number[]> {
    return this.api.put<number[]>(`shoppers/${shopperId}/watchlist/${listingId}`, null);
  }

  remove(shopperId: number, listingId: number): Observable<number[]> {
    return this.api.delete<number[]>(`shoppers/${shopperId}/watchlist/${listingId}`);
  }
}
